import { render, staticRenderFns } from "./ArenaUserForm.vue?vue&type=template&id=6e686616"
import script from "./ArenaUserForm.vue?vue&type=script&lang=js"
export * from "./ArenaUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports